

const TeamCard = ({ member }) => {
  return (
    <div className="flex flex-col items-center my-4 p-4 space-y-4 text-center bg-white rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-all">
      {/* صورة العضو والدائرة التحميلة */}
      <div className="relative w-60 h-60">
        <img
          src={member.img}
          alt={member.name}
          className="object-cover w-full h-full border-4 border-white rounded-full"
        />
        <svg
          className="absolute top-[-6px] left-[-6px] w-[250px] h-[250px] pointer-events-none"
          viewBox="0 0 100 100"
        >
          <circle
            cx="50"
            cy="50"
            r="49.5"
            stroke="#3B82F6"
            strokeWidth="1.5"
            fill="none"
            strokeDasharray="60 15 60 15 60 15 60 15"
            strokeLinecap="round"
            transform="rotate(11.25 50 50)"
          />
        </svg>
      </div>

      {/* اسم ووظيفة العضو */}
      <div className="flex-grow">
        <h2 className="text-[20px] font-bold text-gray-900">{member.name}</h2>
        <span className="text-mainGray text-sm block mt-1">{member.role}</span>
      </div>
    </div>
  );
};

export default TeamCard;